import css from './frame.module.scss';

import { memo } from 'react';

type TProps =
  | { message: string; subMessage?: string }
  | { children: React.ReactNode };

const FrameMessage = (props: TProps) => (
  <div className={css.message}>
    {'message' in props ? props.message : props.children}
    {'subMessage' in props && props.subMessage && (
      <div className={css.subMessage}>{props.subMessage}</div>
    )}
  </div>
);

export default memo(FrameMessage);
